import * as React from "react";
import { useState } from "react";
import { Menu } from "components/bootstrap";
import { IconButton } from "components/common";
const FilterEditButton = ({
  filterComponent,
  column,
  value,
  columnTitle,
  onEdit,
  selectedValues,
  containerWidth,
  onDelete
}) => {
  var _a, _b;
  const [open, setOpen] = useState(false);
  const [editValue, setEditValue] = useState(value);
  const submitChanges = (newValue) => {
    if (newValue) {
      onEdit(newValue);
    } else {
      onDelete();
    }
    setEditValue(null);
    setOpen(false);
  };
  const onChange = (newValue, shouldSubmit = true) => {
    var _a2, _b2;
    const normalizedValue = (_b2 = (_a2 = filterComponent == null ? void 0 : filterComponent.valueForConfig) == null ? void 0 : _a2.call(filterComponent, newValue)) != null ? _b2 : newValue;
    setEditValue(normalizedValue);
    if (shouldSubmit) {
      submitChanges(normalizedValue);
    }
  };
  const onClose = () => {
    setOpen(false);
    if (filterComponent.submitChangesOnClose) {
      submitChanges(editValue);
    }
  };
  if (!filterComponent) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    Menu,
    {
      position: "bottom-end",
      withinPortal: true,
      opened: open,
      width: containerWidth,
      offset: { alignmentAxis: -25 },
      onClose
    },
    /* @__PURE__ */ React.createElement(Menu.Target, null, /* @__PURE__ */ React.createElement(IconButton, { name: "edit", title: `Edit ${columnTitle(column)} filter`, onClick: () => setOpen(true) })),
    /* @__PURE__ */ React.createElement(Menu.Dropdown, null, filterComponent.configuration(
      selectedValues,
      (_b = (_a = filterComponent.valueFromConfig) == null ? void 0 : _a.call(filterComponent, editValue)) != null ? _b : editValue,
      onChange
    ))
  );
};
export default FilterEditButton;
